<template>
  <!-- drawer 侧拉模式 -->
  <div v-if="isDrawer" class="drawer-wrapper" :class="{ 'drawer-collapsed': !drawerOpen }">
    <!-- 收起/展开 tab 按钮（在 container 外，不随面板滑走） -->
    <img
      class="drawer-toggle-btn"
      src="@/assets/全球说/drawer-close.png"
      @click="drawerOpen = !drawerOpen"
      alt="收起/展开"
    />
    <div class="drawer-container">
      <!-- 关闭按钮（左上角叉） -->
      <img
        class="drawer-x-btn"
        src="@/assets/全球说/close.png"
        @click="closeDialog"
        alt="关闭"
      />
      <!-- 标题 -->
      <div class="title-text">{{ $t('teacher.qa.title') }}</div>
      <!-- 聊天区域 -->
      <div class="chat-area">
        <div class="chat-messages" ref="chatMessages">
          <!-- 默认老师消息 -->
          <div class="message teacher-message">
            <img
              class="avatar teacher-avatar"
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
              v-if="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl"
            />
            <div class="message-bubble teacher-bubble">
              <MarkMathRenderer :content="teacherAsking.currentAction && teacherAsking.currentAction.examText ? teacherAsking.currentAction.examText : '请输入您的回答'" />
              <img
                v-if="teacherAsking.currentAction && teacherAsking.currentAction.quesUrl"
                :src="teacherAsking.currentAction.quesUrl"
                alt="题目配图"
                class="message-image"
                style="max-width: 200px; max-height: 200px; border-radius: 8px; display: block; margin-top: 8px;"
              />
            </div>
          </div>
          <!-- 动态消息列表 -->
          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="['message', message.type === 'student' ? 'student-message' : 'teacher-message']"
          >
            <img
              v-if="message.type === 'teacher'"
              class="avatar teacher-avatar"
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
            />
            <img
              v-if="message.type === 'student'"
              class="avatar student-avatar"
              src="@/assets/全球说/student.png"
              alt="学生头像"
            />
            <div :class="['message-bubble', message.type === 'student' ? 'student-bubble' : 'teacher-bubble']">
              <img
                v-if="message.isImage"
                :src="message.content"
                alt="手写答案"
                class="message-image"
                style="max-width: 200px; max-height: 200px; border-radius: 8px;"
              />
              <div v-else-if="message.isAudio" style="display:flex;align-items:center;gap:8px;max-width:100%">
                <audio :src="message.audioUrl" controls style="max-width:100%"></audio>
              </div>
              <MarkMathRenderer v-else :content="message.content" />
            </div>
          </div>
          <!-- Loading气泡 -->
          <div v-if="isTeacherStreaming" class="message teacher-message">
            <img
              class="avatar teacher-avatar"
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
              v-if="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl"
            />
            <div class="message-bubble teacher-bubble loading-bubble">
              <div class="loading-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 输入区域 -->
      <div class="input-area" v-show="hasInputArea">
        <div class="input-container">
          <div class="text-input-container">
            <WaveCanvas :enabled="true" :opacity="0.4" class="wave-background" />
            <textarea
              v-model="inputText"
              class="text-input"
              :placeholder="$t('teacher.qa.input_hint')"
              @input="onInputChange"
            ></textarea>
            <div class="input-controls">
              <img
                class="control-icon"
                src="@/assets/全球说/navigation.png"
                @click="sendTextMessage"
                alt="发送"
              />
            </div>
          </div>
        </div>
        <div v-if="countDownText" class="countdown-container">
          <div class="recording-indicator">
            <div class="recording-dot"></div>
            <span class="recording-text">{{ $t('teacher.qa.recording') }}</span>
          </div>
          <img :src="channel.teacherAskCountDownClockGifImg()" class="countdown-clock">
          <span class="countdown-text">{{countDownText}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- 弹窗模式（默认） -->
  <div v-else class="dialog-overlay">
    <div class="dialog-container">
      <!-- 标题 -->
      <div class="title-text">{{ $t('teacher.qa.title') }}</div>
      
      <!-- 关闭按钮 -->
      <img 
        class="close-btn" 
        src="@/assets/全球说/close.png" 
        @click="closeDialog"
        alt="关闭"
      />
      
      <!-- 聊天区域 -->
      <div class="chat-area">
        <div class="chat-messages" ref="chatMessages">
          <!-- 默认老师消息 -->
          <div class="message teacher-message">
            <img 
              class="avatar teacher-avatar" 
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
              v-if="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl"
            />
            <div class="message-bubble teacher-bubble">
              <MarkMathRenderer :content="teacherAsking.currentAction && teacherAsking.currentAction.examText ? teacherAsking.currentAction.examText : '请输入您的回答'" />
              <img 
                v-if="teacherAsking.currentAction && teacherAsking.currentAction.quesUrl"
                :src="teacherAsking.currentAction.quesUrl"
                alt="题目配图"
                class="message-image"
                style="max-width: 200px; max-height: 200px; border-radius: 8px; display: block; margin-top: 8px;"
              />
            </div>
          </div>
          
          <!-- 动态消息列表 -->
          <div 
            v-for="(message, index) in messages" 
            :key="index"
            :class="['message', message.type === 'student' ? 'student-message' : 'teacher-message']"
          >
            <img 
              v-if="message.type === 'teacher'"
              class="avatar teacher-avatar" 
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
            />
            <img 
              v-if="message.type === 'student'"
              class="avatar student-avatar" 
              src="@/assets/全球说/student.png"
              alt="学生头像"
            />
            <div :class="['message-bubble', message.type === 'student' ? 'student-bubble' : 'teacher-bubble']">
              <img 
                v-if="message.isImage" 
                :src="message.content" 
                alt="手写答案" 
                class="message-image"
                style="max-width: 200px; max-height: 200px; border-radius: 8px;"
              />
              <div v-else-if="message.isAudio" style="display:flex;align-items:center;gap:8px;max-width:100%">
                <audio :src="message.audioUrl" controls style="max-width:100%"></audio>
              </div>
              <MarkMathRenderer v-else :content="message.content" />
            </div>
          </div>
          
          <!-- Loading气泡 - 当老师正在推流时显示 -->
          <div 
            v-if="isTeacherStreaming"
            class="message teacher-message"
          >
            <img 
              class="avatar teacher-avatar" 
              :src="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl ? teacherAsking.currentAction.teacherImgUrl : ''"
              alt="老师头像"
              v-if="teacherAsking.currentAction && teacherAsking.currentAction.teacherImgUrl"
            />
            <div class="message-bubble teacher-bubble loading-bubble">
              <div class="loading-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <!-- 输入区域 -->
      <div class="input-area" v-show="hasInputArea">
        <div class="input-container">
          <!-- 文字输入模式 -->
          <div class="text-input-container">
            <!-- 声波背景组件 -->
            <WaveCanvas 
              :enabled="true" 
              :opacity="0.4"
              class="wave-background"
            />
            <textarea 
              v-model="inputText"
              class="text-input"
              :placeholder="$t('teacher.qa.input_hint')"
              @input="onInputChange"
            ></textarea>
            <div class="input-controls">
              <!-- <span class="submit-hint">回答完毕点击提交</span> -->
              <img 
                class="control-icon" 
                src="@/assets/全球说/navigation.png" 
                @click="sendTextMessage"
                alt="发送"
              />
            </div>
          </div>
        </div>
        
        <!-- 倒计时 -->
        <div v-if="countDownText" class="countdown-container">
          <!-- 录音状态指示器 -->
          <div class="recording-indicator">
            <div class="recording-dot"></div>
            <span class="recording-text">{{ $t('teacher.qa.recording') }}</span>
          </div>
          <img :src="channel.teacherAskCountDownClockGifImg()" class="countdown-clock">
          <span class="countdown-text">{{countDownText}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WaveCanvas from './WaveCanvas.vue';
import MarkMathRenderer from './MarkMathRenderer.vue';

export default {
  name: 'TeacherAskingDialog',
  components: {
    WaveCanvas,
    MarkMathRenderer
  },
  props: {
    teacherAskingData: {
      required: true
    },
    channel: null,
    mainObj: null,
    isStreaming: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      messages: [],
      inputText: '',
      teacherAsking: {},
      drawerOpen: true
    };
  },
  computed: {
    isDrawer() {
      return this.teacherAsking.currentAction && this.teacherAsking.currentAction.quesStyle === 'drawer';
    },
    countDownText() {
      return this.teacherAsking.countDownText || '';
    },
    isTeacherStreaming() {
      // 使用更准确的isStreaming状态来控制loading气泡的显示
      // 只有在真正推流时才显示loading气泡，而不是依赖bShowThinking
      return this.isStreaming && !this.hasTeacherMessages();
    },
    hasInputArea() {
      // 当教师正在推流时或收到exitDialogue信号时隐藏输入框
      return !(this.teacherAsking.bHandling || this.teacherAsking.bShowThinking || this.teacherAsking.bExitDialogue);
    }
  },
  watch: {
    teacherAskingData: {
      immediate: true,
      handler(newContent) {
        this.teacherAsking = newContent;
        // 同步输入框内容
        if (this.teacherAsking.currentAction && this.teacherAsking.currentAction.userAnswerText) {
          this.inputText = this.teacherAsking.currentAction.userAnswerText;
        }
        // 同步对话历史到messages数组
        this.syncDialogueHistory();
      }
    },
    'teacherAsking.dialogueHistory': {
      deep: true,
      handler() {
        this.syncDialogueHistory();
      }
    },
    'teacherAsking.answerText': {
      handler(newVal) {
        // 当answerText更新时，实时显示在聊天区域
        if (newVal && this.teacherAsking.bShowAnswer) {
          this.updateCurrentTeacherMessage(newVal);
        }
      }
    },
    // 监听推流状态变化，自动滚动到底部
    'teacherAsking.bShowThinking': {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    inputText(newVal) {
      // 同步到原有的数据结构
      if (this.teacherAsking.currentAction) {
        this.teacherAsking.currentAction.userAnswerText = newVal;
      }
    }
  },
  methods: {
    hasTeacherMessages() {
      // 检查是否已经有老师的消息在对话历史中
      return this.messages.some(msg => msg.type === 'teacher');
    },
    
    sendTextMessage() {
      
      // 添加学生消息到聊天区域
      this.messages.push({
        type: 'student',
        content: this.inputText
      });
      
      // 调用原有的发送逻辑
      this.mainObj.onUserClickSendAnswerForTeacherAsking();
      
      // 发送后立即清空输入框（所有模式下都清空）
      this.inputText = '';
      // 同时清空 HomeView 中的 userAnswerText
      if (this.teacherAsking.currentAction) {
        this.teacherAsking.currentAction.userAnswerText = '';
      }
      
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    
    onInputChange() {
      // 可以在这里添加字数统计等逻辑
    },
    
    scrollToBottom() {
      const chatMessages = this.$refs.chatMessages;
      if (chatMessages) {
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }
    },
    
    // 同步对话历史到messages数组
    syncDialogueHistory() {
      if (!this.teacherAsking.dialogueHistory) return;
      
      this.messages = [];
      this.teacherAsking.dialogueHistory.forEach(item => {
        if (item.role === 'user') {
          if (item.type === 'image') {
            // 处理图片类型的用户消息
            this.messages.push({
              type: 'student',
              content: item.content,
              isImage: true
            });
          } else if (item.type === 'audio') {
            let audioUrl = ''
            try {
              const audioData = JSON.parse(item.content)
              audioUrl = audioData.audioUrl || ''
            } catch(e) { audioUrl = '' }
            if (audioUrl) {
              this.messages.push({
                type: 'student',
                isAudio: true,
                audioUrl: audioUrl
              })
            }
          } else {
            this.messages.push({
              type: 'student',
              content: item.content,
              isImage: false
            });
          }
        } else if (item.role === 'teacher') {
          // 根据类型处理不同的内容
          let content = '';
          if (item.type === 'text') {
            content = item.content;
          } else if (item.type === 'audio') {
            try {
              const audioData = JSON.parse(item.content);
              content = audioData.dispText || audioData.audioText || '';
            } catch (e) {
              content = item.content;
            }
          } else if (item.type === 'blackboard') {
            content = item.content;
          } else if (item.type === 'audioDisp') {
            content = item.content;
          } else {
            content = item.content;
          }
          
          if (content) {
            this.messages.push({
              type: 'teacher',
              content: content,
              isImage: false
            });
          }
        }
      });
      
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    
    // 更新当前教师消息（用于推流时实时显示）
    updateCurrentTeacherMessage() {
      // 推流过程中不使用这个方法更新消息，因为我们已经通过dialogueHistory逐条添加
      // 这个方法现在主要用于兼容性，避免报错
      console.log('updateCurrentTeacherMessage 被调用，但推流内容已通过 dialogueHistory 逐条添加');
      
      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    
    closeDialog() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* ========== Drawer 侧拉模式 ========== */
.drawer-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: all;
  background-color: rgba(0, 0, 0, 0.5);
  transition: background-color 0.35s ease;
}

.drawer-wrapper.drawer-collapsed {
  background-color: rgba(0, 0, 0, 0);
  pointer-events: none;
}

.drawer-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 100%;
  background-image: url('@/assets/全球说/drawer-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  transform: translateX(0);
  transition: transform 0.35s ease;
  pointer-events: all;
}

.drawer-collapsed .drawer-container {
  transform: translateX(100%);
}

/* tab 按钮固定在视口，始终可点击 */
.drawer-toggle-btn {
  position: fixed;
  right: 30%;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: auto;
  cursor: pointer;
  z-index: 2;
  pointer-events: all;
  transition: right 0.35s ease;
}

.drawer-collapsed .drawer-toggle-btn {
  right: 0;
}

.drawer-x-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;
}

/* drawer 模式下复用弹窗内部布局，额外覆盖 margin-top */
.drawer-container .chat-area {
  flex: 1;
  padding: 20px 20px 0 20px;
  margin-top: 70px;
  overflow: hidden;
}

/* ========== 弹窗模式 ========== */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-container {
  width: 60%;
  max-width: 800px;
  aspect-ratio: 1330/733;
  background-image: url('@/assets/全球说/ques-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.title-text {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: #734719;
  background-image: url('@/assets/全球说/zhuangshi.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 4px bottom;
  z-index: 10;
  font-weight: bold;
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 10;
}

.chat-area {
  flex: 1;
  padding: 20px;
  margin-top: 80px;
  overflow: hidden;
}

.chat-messages {
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;
}

.message {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.teacher-message {
  justify-content: flex-start;
}

.student-message {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.teacher-avatar {
  border: 2px solid #EEE2D8;
}

.student-avatar {
  border: 2px solid #C3A281;
}

.message-bubble {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 8px;
  word-wrap: break-word;
  line-height: 1.4;
}

.teacher-bubble {
  background-color: #EEE2D8;
  color: #734719;
}

.student-bubble {
  background-color: #C3A281;
  color: #FFFFFF;
}

.input-area {
  padding: 15px 20px 20px 20px;
  position: relative;
}

.input-container {
  background-image: url('@/assets/全球说/ques-input.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  aspect-ratio: 4/1;
  position: relative;
  display: flex;
  align-items: center;
}

.text-input-container {
  width: 99%;
  height: 96%;
  margin-left: 3px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  position: relative; /* 为绝对定位的背景提供参考 */
}

/* 声波背景样式 */
.wave-background {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}

.text-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #C3A281;
  font-size: 14px;
  resize: none;
  height: 60%;
  padding: 5px;
  position: relative;
  z-index: 2; /* 确保文本在声波背景之上 */
}

.text-input::placeholder {
  color: #C3A281;
  opacity: 0.7;
}

.input-controls {
  position: absolute;
  bottom: 20px;
  right: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}

.submit-hint {
  font-size: 12px;
  color: #C3A281;
  opacity: 0.7;
  white-space: nowrap;
}

.control-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s;
}

.control-icon:hover {
  transform: scale(1.1);
}

.countdown-container {
  position: absolute;
  right: 20px;
  top: -5px;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100% - 16px);
  overflow: hidden;
}

.recording-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
}

.recording-dot {
  width: 8px;
  height: 8px;
  background-color: #ff0000;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

.recording-text {
  font-size: 12px;
  color: #ff0000;
  white-space: nowrap;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.countdown-clock {
  height: 16px;
  flex: 0 0 auto;
}

.countdown-text {
  font-size: small;
  color: #C3A281;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1 auto;
}

/* Loading气泡样式 */
.loading-bubble {
  background-color: #EEE2D8;
  color: #734719;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
}

.loading-dots {
  display: flex;
  gap: 4px;
  align-items: center;
}

.loading-dots .dot {
  width: 6px;
  height: 6px;
  background-color: #734719;
  border-radius: 50%;
  animation: loading-bounce 1.4s infinite ease-in-out both;
}

.loading-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-dots .dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes loading-bounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: #C3A281;
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #A08660;
}
</style>
